var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { SwingBySwingApi } from "../services/swingbyswingapi";
import { HttpResponseMessage, HandicapEntryCollection } from "../lib/types";
var Handicap = /** @class */ (function (_super) {
    __extends(Handicap, _super);
    function Handicap() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Returns a players handicap entries
     *
     * @param from     The first handicap entry to get
     * @param to       The last handicap entry to get
     */
    Handicap.prototype.entries = function (playerId, from, to) {
        var _this = this;
        if (playerId === void 0) { playerId = ""; }
        if (from === void 0) { from = 1; }
        if (to === void 0) { to = 20; }
        // Get players handicap entries and return them
        return this.request("GET", "handicapentries/" + playerId, {
            from: from,
            to: to
        }).then(function (r) {
            // Map entries to type
            return _this.mapResponse(new HandicapEntryCollection(), r.data);
        });
    };
    /**
     * Get a single handicap entry
     *
     * @param handicapId
     */
    Handicap.prototype.specific = function (handicapId) {
        return this.request("GET", "handicapentry/" + handicapId).then(function (r) {
            return r.data;
        });
    };
    /**
     * Deletes a handicap for a player
     *
     * @param handicapId The handicap to delete
     */
    Handicap.prototype["delete"] = function (playerId, handicapId) {
        var _this = this;
        // Delete the handicap
        return this.request("DELETE", "handicapentries/" + playerId + "/" + handicapId).then(function (r) {
            // Return the mapped response
            return _this.mapResponse(new HttpResponseMessage(), r.data);
        });
    };
    Handicap.prototype.getTeeTypesForCourse = function (courseId) {
        return this.request("GET", "courses/" + courseId).then(function (r) {
            return r.data.stats;
        });
    };
    Handicap.prototype.update = function (entryId, adjustedGrossScore, teeType, courseRating, courseSlope, courseName) {
        return this.request("PUT", "handicapentries/me/" + entryId, {
            adjustedGrossScore: adjustedGrossScore,
            teeType: teeType,
            courseRating: courseRating,
            courseSlope: courseSlope,
            courseName: courseName
        }).then(function (r) {
            //console.log("REPONSOSOO:", r);
        });
    };
    return Handicap;
}(SwingBySwingApi));
export { Handicap };
